import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './shared/queryClient';
import DefaultLoading from './components/ui/suspense/DefaultLoading';
import { getBrowserRouterBasePath } from './shared/config/publicAssetPath';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const browserRouterBasePath = getBrowserRouterBasePath();

root.render(
  <Suspense fallback={<DefaultLoading />}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={browserRouterBasePath || undefined}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </Suspense>,
);

reportWebVitals();
